import { render } from "./OurValue.vue?vue&type=template&id=ceccf424"
import script from "./OurValue.vue?vue&type=script&lang=js"
export * from "./OurValue.vue?vue&type=script&lang=js"

import "./OurValue.vue?vue&type=style&index=0&id=ceccf424&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__